import 'jquery-captcha';


window.refreshCaptchaContact = () => {
    $('#frontal').remove();
    $('.btn-refresh').remove();
    $('.captcha_contact').each(function() {
        getCaptcha('captchetat_contact');
    });
    event.preventDefault();
}

window.refreshCaptchaNewsletter = () => {
    $('#frontal').remove();
    $('.btn-refresh').remove();
    $('.captcha_newsletter').each(function() {
        getCaptcha('captchetat_newsletter');
    });
    event.preventDefault();
}


$(document).on('turbolinks:load', function() {
    $('.modal-contact').each(function() {
        $(this).on('click', function() {
            if($('#captchetat-container'+'captchetat_contact').length === 0){
                $('.btn-refresh').remove();
                getCaptcha('captchetat_contact');
            }
        });
    });

    $('.modal-newsletter').each(function() {
        $(this).on('click', function() {
            if($('#captchetat-container'+'captchetat_newsletter').length === 0){
                $('.btn-refresh').remove();
                getCaptcha('captchetat_newsletter');
            }
        });
    });

    $('.captcha-wrapper-chiffres').each(function() {
        if($('#captchetat-container'+'captchetat_chiffres').length === 0){
            getCaptcha('captchetat_chiffres');
        }
    });
});
